import * as yup from 'yup'

let animalStepSchema = yup.object().shape({
  pet_species: yup.string().default('').required(),
  pet_age_category: yup.string().default('').required('')
})

export default animalStepSchema